/* Base Urls */
// export const BASE_URL = 'https://pnh.test.improvement-it.nl/api/';
export const BASE_URL = 'https://pnh.digitaalvignet.nl/api/';

/* Auth endpoints */
export const LOGIN_ENDPOINT = 'CheckPinCode';
export const CHANGE_PASSWORD_ENDPOINT = 'UpdatePassword';
export const REFRESH_TOKEN_ENDPOINT = 'refresh/token';

/* User endponts */
export const SAVE_USER_ENDPOINT = 'SaveOwnerDetails';
export const FETCH_USER_ENDPOINT = 'GetOwner';
export const UPDATE_USER_ENDPOINT = 'UpdateOwner';

/* Object endpoints */
export const FETCH_OBJECT_ENDPOINT = 'GetObject';
export const FETCH_BOAT_TYPES_ENDPOINT = 'GetBoatTypes'; 
export const FETCH_JETTY_TYPES_ENDPOINT = 'GetJettyTypes';
export const FETCH_DRIVE_TYPES_ENDPOINT = 'GetDriveTypes';
export const UPDATE_OBJECT_ENDPOINT = 'UpdateObject';

/* Documents endpoints */
export const UPLOAD_DOCUMENT_ENDPOINT = 'UploadDocuments';

/* Image endpoints */
export const UPLOAD_ENDPOINT = 'UploadPicture';

/* Costs */
export const FETCH_COSTS_ENDPOINT = 'GetCosts';

/* Map geoJson */
export const FETCH_GEOJSON_DATA_ENDPOINT = 'GetGeoJson';

